import httpService from "./httpService";
import { deepClean } from "@/utils/commonUtils";

export default {
    getCounters: async (params) => {
        return await httpService.get('counters', { params: deepClean(params) }); 
    },
    getWalks: async () => {
        return await httpService.get('walks'); 
    },
    getSponsors: async () => {
        return await httpService.get('sponsors'); 
    },
    getCityProclamations: async () => {
        return await httpService.get('city-proclamations');
    },
    getJoinWalksDetails: async (params) => {
        return await httpService.get('join-walks-details', { params: deepClean(params) });
    },
    getWalksByThemeLocation: async (params) => {
        return await httpService.get('walks-by-theme-location', { params: deepClean(params) });
    },
};
